// GENERATED by scripts/build-icons.mjs from icons/square.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Square = createIcon('square', [
  ['rect', { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
])
